import * as React from 'react';
import CountrySelector from "../CountrySelector";
import { SeoHeaderImage } from "./SeoHeaderImage";
var KitHeader = function () {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center frameless l-container h-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-100 tablet-grid-100 mobile-grid-100 h-pos-relative"
  }, /*#__PURE__*/React.createElement(CountrySelector, null))), /*#__PURE__*/React.createElement(SeoHeaderImage, null));
};
export default KitHeader;